import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export interface PendingVoidInvoiceDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  isSubmitting: boolean;
}

export const PendingVoidInvoiceDialog: React.FC<PendingVoidInvoiceDialogProps> = ({
  open,
  onClose,
  onConfirm,
  isSubmitting,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle>Void Invoice</DialogTitle>
    <DialogContent>
      <DialogContentText>Are you sure you want to void this invoice? This action cannot be undone.</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={isSubmitting} sx={{ textTransform: "none" }}>
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        variant="contained"
        color="error"
        disabled={isSubmitting}
        sx={{ textTransform: "none" }}
      >
        Void
      </Button>
    </DialogActions>
  </Dialog>
);

export default PendingVoidInvoiceDialog;
